export type ExportFormatSVG = "svg" | "cuttle.svg";
export type ExportFormat = ExportFormatSVG | "pdf" | "png" | "dxf";

export type PostprocessSVG = "none" | "glowforge" | "cricut";
export const isValidPostprocessSVG = (postprocess: unknown): postprocess is PostprocessSVG => {
  return postprocess === "none" || postprocess === "glowforge" || postprocess === "cricut";
};
